import './Noticias.css'
import CardNoticias from './CardNoticias';
import { CardGroup, Container } from 'react-bootstrap';
import PrincipalNoticia from './PrincipalNoticia';

const Noticias = (props) => {
    return (                  
            <div className='row noticias'>
                    <div className='col-sm noticia-principal'>
                        <PrincipalNoticia
                        imagem={"imagens/noticias/-2023-01-10-qYRlDifAry.jpg"} 
                        titulo = {"Governo tenta antecipar mais de 7 milhões de doses para continuar vacinação infantil contra a Covid"} 
                        texto = {""} 
                        titulo_botao = {"Veja mais"} 
                        link_botao = {"https://www.canalsaude.fiocruz.br/noticias/noticiaAberta/onu-afirma-que-responsaveis-por-ataques-no-brasil-devem-sofrer-consequencias10012023"}
                        rodape = {"10/01/2023"}
                        ></PrincipalNoticia>
                    </div>
                    <div className='col-sm lasted-news'>
                        <h3>Latest news</h3>
                        <div className='col-12'>
                            <CardNoticias 
                                imagem={"imagens/noticias/-2023-01-10-mXOsocHEaV.jpeg"} 
                                titulo = {"Covid-19: Brasil soma 36.511.286 casos de covid-19 e 694.917 óbitos pela doença"} 
                                texto = {""} 
                                titulo_botao = {"Veja mais"} 
                                link_botao = {"https://www.canalsaude.fiocruz.br/noticias/noticiaAberta/covid-19-brasil-soma-36511286-casos-de-covid-19-e-694917-obitos-pela-doenca10012023"}
                                rodape = {"10/01/2023"}
                            >
                            </CardNoticias>
                        </div>                        
                        <div className='col-12'>
                            <CardNoticias 
                                imagem={"imagens/noticias/placa_petri_colecao_fungos_filamentosos_790_0.jpg"} 
                                titulo = {"Coleção de Fungos da Fiocruz completa 100 anos de história"} 
                                texto = {""} 
                                titulo_botao = {"Veja mais"} 
                                link_botao = {"https://agencia.fiocruz.br/colecao-de-fungos-da-fiocruz-completa-100-anos-de-historia"}
                                rodape = {"10/01/2023"}
                            >
                            </CardNoticias>
                        </div>
                        <div className='col-12'>
                            <CardNoticias 
                                imagem={"imagens/noticias/radar_saude_favela_21.jpeg"} 
                                titulo = {"Radar Saúde Favela debate sobre literatura, periferia e saúde"} 
                                texto = {""} 
                                titulo_botao = {"Veja mais"} 
                                link_botao = {"https://agencia.fiocruz.br/radar-saude-favela-debate-sobre-literatura-periferia-e-saude"}
                                rodape = {"10/01/2023"}
                            >

                            </CardNoticias>
                        </div>
                    </div>
                </div>
    )
}

export default Noticias